const styles = {
  selectContainer:
    "text-sm md:text-base relative my-4 md:my-0 text-black font-medium dark:text-white",
  select:
    "bg-white dark:bg-defaultBlack w-44 font-semibold rounded-md text-sm p-2 justify-between inline-flex items-center ",
  languagesList: "bg-white dark:bg-defaultBlack font-semibold text-sm",
  language:
    "cursor-pointer p-2 inline-flex items-center w-full gap-2 hover:bg-black/20 overflow-hidden dark:bg-defaultBlack dark:hover:bg-white/10 ",
  dropDownIcon: "w-5 h-5 text-defaultBlack dark:text-white",
  flagIcon: "h-6 w-6",
  listContainer:
    "w-44 bg-white absolute rounded-md top-auto right-auto bottom-auto left-0 my-1  transition-all duration-300 overflow-hidden flex items-center",
  btnContent: "inline-flex items-center gap-2",
};
export default styles;
